import { XpressDisciplinaryActionEnum } from 'app/models';

export class XpressDisciplinaryActionModel {
    public static XpressDisciplinaryActionList: Array<any> = [
        { name: 'Closed', value: XpressDisciplinaryActionEnum.Closed },
        { name: 'Suspension', value: XpressDisciplinaryActionEnum.Suspension },
        { name: 'Ban', value: XpressDisciplinaryActionEnum.Ban },
        { name: 'Temporary Suspended', value: XpressDisciplinaryActionEnum.TemporarySuspended }
    ];
}
